import { render } from "./DraftCard.vue?vue&type=template&id=0e8854d5&scoped=true"
import script from "./DraftCard.vue?vue&type=script&lang=js"
export * from "./DraftCard.vue?vue&type=script&lang=js"

import "./DraftCard.vue?vue&type=style&index=0&id=0e8854d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8854d5"]])

export default __exports__